import { render, staticRenderFns } from "./SetUpEvaluate.vue?vue&type=template&id=7b07ce97&scoped=true&"
import script from "./SetUpEvaluate.vue?vue&type=script&lang=js&"
export * from "./SetUpEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./SetUpEvaluate.vue?vue&type=style&index=0&id=7b07ce97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b07ce97",
  null
  
)

export default component.exports